export default values => {
    const errors = {};
    const requiredFields = ["status", "name", "description"];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "Required";
        }
    });
    return errors;
};
